import React from 'react';
import uuid from 'uuid-random';
import { ButtonIconPosition } from 'react-magma-dom';
import { Button } from './Button';
import { KeyboardArrowLeftIcon, KeyboardArrowRightIcon } from 'react-magma-icons';
import {
  IData,
  LEFT_NAV_BUTTON,
  RIGHT_NAV_BUTTON,
  BOTH_NAV_BUTTON,
  LEFT_NAV_DATA,
  RIGHT_NAV_DATA,
  BOTH_NAV_DATA,
  LANGUAGE_FEATURES,
  TEXT_PRESENTATION,
} from '../../constants/navigation';
import { TextTypes } from '../../types';

export const pageNavigationRender = (
  redirectByClick: (page: string) => void,
  page: string,
  textType?: string
): JSX.Element => {
  let navElement = <></>;

  const isTextPresentationPage = page === TEXT_PRESENTATION;
  const redirectPage = isTextPresentationPage ? LANGUAGE_FEATURES : TEXT_PRESENTATION;
  const btnText = isTextPresentationPage ? 'Language features' : 'Text presentation';

  const hybridTextTypeData = { redirectPage, btnText };

  if (LEFT_NAV_BUTTON.includes(page)) {
    const data = textType && textType === TextTypes.hybrid ? hybridTextTypeData : LEFT_NAV_DATA[page];
    navElement = getLeftSideNavButton(redirectByClick, data);
  }

  if (RIGHT_NAV_BUTTON.includes(page)) {
    const data = textType && textType === TextTypes.hybrid ? hybridTextTypeData : RIGHT_NAV_DATA[page];
    navElement = getRightSideNavButton(redirectByClick, data);
  }

  if (BOTH_NAV_BUTTON.includes(page)) {
    const data = BOTH_NAV_DATA[page];
    navElement = getBothNavButtons(redirectByClick, data);
  }

  return <div>{navElement}</div>;
};

const getLeftSideNavButton = (redirectByClick: (page: string) => void, data: IData): JSX.Element => (
  <Button
    key={uuid()}
    text={`${data.btnText}`}
    onClick={() => redirectByClick(`../${data.redirectPage}`)}
    icon={<KeyboardArrowLeftIcon />}
    iconPosition={ButtonIconPosition.left}
    ariaLabel={`${data.btnText} visited link`}
  />
);

export const getRightSideNavButton = (
  redirectByClick: (page: string) => void | undefined,
  data: IData
): JSX.Element => (
  <Button
    key={uuid()}
    text={`${data.btnText}`}
    onClick={() => redirectByClick(`../${data.redirectPage}`)}
    icon={<KeyboardArrowRightIcon />}
    iconPosition={ButtonIconPosition.right}
    ariaLabel={`${data.btnText} visited link`}
  />
);

export const getBothNavButtons = (
  redirectByClick: (page: string) => void,
  data: { [index: string]: IData }
): JSX.Element => (
  <>
    {getLeftSideNavButton(redirectByClick, data.left)}
    {getRightSideNavButton(redirectByClick, data.right)}
  </>
);

export const getNavButtonForExtendingStage = (redirectByClick: (page: string) => void, data: IData): JSX.Element => (
  <>
    {data.redirectPage === TEXT_PRESENTATION
      ? getLeftSideNavButton(redirectByClick, data)
      : getRightSideNavButton(redirectByClick, data)}
  </>
);
